/* @flow weak */
import thunk from "redux-thunk";
import createLoggerMiddleware from "redux-logger";

// Deps.
import validate from "./validate";

const configureMiddleware = (
  initialState,
  platformDeps,
  platformMiddleware
) => {
  const middleware = [
    thunk.withExtraArgument({
      ...platformDeps,
      apiHost: initialState.config.apiHost,
      intl: initialState.intl,
      validate
    }),
    ...platformMiddleware
  ];

  const enableLogger = process.env.NODE_ENV !== "production" &&
    process.env.IS_BROWSER;

  // Logger must be the last middleware in chain.
  if (enableLogger) {
    const ignoredActions = [];
    const logger = createLoggerMiddleware({
      collapsed: true,
      predicate: (getState, action) =>
        ignoredActions.indexOf(action.type) === -1,
      // Convert immutable to JSON.
      stateTransformer: state => JSON.parse(JSON.stringify(state))
    });
    middleware.push(logger);
  }

  return middleware;
};

export default configureMiddleware;



// WEBPACK FOOTER //
// ./src/common/configureMiddleware.js